import React from 'react';
import { withRouter, Route} from 'react-router-dom';

// import './index.css' 

const SuperAdminArea = ( {match, history} ) => {
    history.push(match.url + '/org-details')
    return (
        <div></div>
    )
}


export default withRouter(SuperAdminArea)


// WEBPACK FOOTER //
// ./src/_pages/Organzation/SuperAdminArea/index.js